export default "__VITE_ASSET__BdvA2sZQ__"